import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { CorporateRoutingComponent } from './components/corporate-routing/corporate-routing.component';
import { corporateAdminOrTravelBookerGuard } from './guards/corporate-admin-or-travel-booker.guard';
import { corporateChildGuard, corporateGuard, featureFlagGuardData } from './guards/corporate.guard';
import { AddUserComponent } from './components/add-user/add-user.component';
import { CorporateHomeComponent } from './components/pages/corporate-home/corporate-home.component';
import { CorporateTripsComponent } from './components/pages/corporate-trips/corporate-trips.component';
import { CorporateUsersComponent } from './components/pages/corporate-users/corporate-users.component';
import { CorporateCompanyComponent } from './components/pages/corporate-company/corporate-company.component';
import { CorporateDataPageComponent } from './components/pages/corporate-spend/corporate-data-page.component';
import { corporateUserIdResolver } from './resolvers/corporate-user-id.resolver';
import { corporateAdminGuard } from './guards/corporate-admin.guard';
import { changePasswordGuard } from './guards/change-password.guard';
import { ChoooseRedirectorComponent } from './components/chooose-redirector/chooose-redirector.component';
import { choooseGuard } from './guards/chooose.guard';

export const corporateRoutes: Routes = [
  {
    path: '',
    component: CorporateRoutingComponent,
    children: [
      {
        path: 'home',
        component: CorporateHomeComponent,
      },
      {
        path: 'trips',
        component: CorporateTripsComponent,
      },
      {
        path: 'users',
        component: CorporateUsersComponent,
      },
      {
        path: 'users/me',
        component: CorporateUsersComponent,
        resolve: { userId: corporateUserIdResolver },
      },
      {
        path: 'add-user',
        component: AddUserComponent,
        canActivate: [corporateAdminOrTravelBookerGuard],
      },
      {
        path: 'company',
        component: CorporateCompanyComponent,
      },
      {
        path: 'data',
        canActivate: [featureFlagGuardData, corporateAdminGuard],
        component: CorporateDataPageComponent,
      },
      {
        path: 'change-password',
        component: CorporateRoutingComponent,
        canActivate: [changePasswordGuard],
      },
      {
        path: 'chooose',
        component: ChoooseRedirectorComponent,
        canActivate: [choooseGuard],
      },
    ],
    runGuardsAndResolvers: 'always',
    canActivate: [corporateGuard],
    canActivateChild: [corporateChildGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(corporateRoutes)],
  declarations: [],
  providers: [],
  exports: [RouterModule],
})
export class CorporateRoutesModule {}
